import PropTypes from 'prop-types';
import createRenderPromises, { propType as renderPromisesPropType } from './ssr/render-promises';
import createComponentsStore, { propType as componentsStorePropType } from './context/components-store';
import createDataProviders, { propType as dataProvidersPropType } from './context/data-providers';
import { schemaPropType } from './lib/validate-schema';
export default function createClient(options) {
  var schema = options.schema,
      components = options.components;
  var componentsStore = createComponentsStore({
    components: components
  });
  var dataProviders = options.dataProviders || createDataProviders({
    providers: options.providers
  }); // client creates a renderPromises instance for use in both server and browser

  var renderPromises = createRenderPromises(options.isomorphicState);

  var extract = function extract() {
    return renderPromises.extract();
  };

  return {
    schema: schema,
    componentsStore: componentsStore,
    dataProviders: dataProviders,
    renderPromises: renderPromises,
    extract: extract
  };
}
export var propType = PropTypes.shape({
  /**
   * Structured Content Schema
   */
  schema: schemaPropType,
  // eslint-disable-line react/require-default-props

  /**
   * instance of createComponentsStore({ components })
   */
  componentsStore: componentsStorePropType.isRequired,

  /**
   * instance of createDataProviders({ providers })
   */
  dataProviders: dataProvidersPropType.isRequired,

  /**
   * returns state of all data gathered during render of a tree with StructuredContent,
   * use output of this method to pass `isomorphicState` from server to browser
   */
  extract: PropTypes.func.isRequired,

  /**
   * (internal) instance of `createRenderPromises(isomorphicState)`
   */
  renderPromises: renderPromisesPropType.isRequired
});